/* eslint-disable max-lines */
import { css } from 'linaria';

export const reviewsCatalogItemAddWrapper = css`
  display: flex;
  column-gap: 8px;
`;

export const reviewsCatalogModal = css`
  && {
    max-width: 100%;
    height: calc(100vh - 32px);
    margin: 16px 0;
    border-radius: var(--rounding-l);
    user-select: none;

    @media (--to-desktop) {
      position: fixed;
      width: 100vw;
      max-width: 100vw;
      min-height: 100vh;

      /* mobile viewport bug fix */
      height: fill-available;
      margin: 0 -16px;
      border-radius: 0;
    }
  }
`;

export const reviewsCatalogModalContent = css`
  position: relative;
  display: grid;
  grid-template-columns: 51.2vw 36.9vw;
  height: 100%;
  padding: 48px;
  column-gap: 2.5vw;

  @media (--from-desktop) {
    &::before,
    &::after {
      position: absolute;
      right: 0;
      width: 100%;
      height: 35px;
      content: '';
    }

    &::before {
      top: 0;
      background: linear-gradient(0deg, rgb(255 255 255 / 0%) 0%, #fff 100%);
    }

    &::after {
      bottom: 0;
      background: linear-gradient(180deg, rgb(255 255 255 / 0%) 0%, #fff 100%);
    }
  }

  @media (--only-desktop) {
    grid-template-columns: 54.9vw 28.1vw;
    padding-bottom: 42px;
    column-gap: 2.3vw;
  }

  @media (--to-desktop) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin-top: 80px;
    overflow-y: auto;
    column-gap: 0;
    row-gap: 10px;
  }

  @media (--only-mobile) {
    margin-top: 64px;
    row-gap: 0;
  }
`;

export const reviewsCatalogImageSwiperBig = css`
  && {
    width: 100%;
    height: calc(100vh - 206px);
    margin-bottom: 32px;

    @media (--only-desktop) {
      height: calc(100vh - 202px);
    }

    @media (--to-desktop) {
      width: 100vw;
      height: auto;
      padding: 0;
      margin: 0;
      margin-bottom: 34px;
    }

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const reviewsCatalogImageSwiperSmall = css`
  && {
    width: 100%;

    @media (--to-desktop) {
      padding: 0;
      padding-left: 16px;
      margin: 0;
    }
  }
`;

export const reviewsCatalogImageBig = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const reviewsCatalogSlideThumb = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: 4px;
  cursor: pointer;

  &&.swiper-slide-thumb-active {
    border: 2px solid var(--control-primary);
    border-radius: var(--rounding-m);
  }

  :last-of-type {
    margin-right: 0;
  }
`;

export const reviewsCatalogImageThumb = css`
  object-fit: cover;
  width: 32px;
  height: 32px;
`;

export const reviewsCatalogModalTextWrapper = css`
  @media (--from-desktop) {
    padding: 48px 0;
    margin: -48px 0;
    overflow-y: auto;
    scrollbar-width: none;
  }

  @media (--to-desktop) {
    padding: 16px;
  }
`;

export const reviewsCatalogModalAddDataWrapper = css`
  @media (--only-mobile) {
    display: flex;
    align-items: center;
  }
`;

export const reviewsCatalogModalRatingWrapper = css`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  column-gap: 8px;

  @media (--only-mobile) {
    margin-bottom: 0;
  }
`;

export const reviewsCatalogModalRatingText = css`
  @media (--only-mobile) {
    display: none;
  }
`;

export const reviewsCatalogModalText = css`
  && {
    width: 31.9vw;
    margin-top: 16px;
    line-height: 28px;

    @media (--to-desktop) {
      width: 100%;
    }

    @media (--only-mobile) {
      margin-top: 8px;
      line-height: 24px;
    }
  }
`;
